export const CREATE_VCG = `
  mutation createVcg($input: CreateVcgInput!) {
    createVcg(input: $input) {
      __typename
      ... on Vcg {
        id
        vcg
        observations
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_VCG = `
  mutation updateVcg($input: UpdateVcgInput!) {
    updateVcg(input: $input) {
      __typename
      ... on Vcg {
        id
        vcg
        observations
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_VCG = `
  mutation deleteVcg($id: Int!) {
    deleteVcg(id: $id) {
      __typename
      ... on Vcg {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
